"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalEvents = void 0;
var GalEvents;
(function (GalEvents) {
    GalEvents["AccountGameIdLinkDTO"] = "AccountGameIdLinkDTO";
    GalEvents["AchievementEarnedDTO"] = "AchievementEarnedDTO";
    GalEvents["BoardCreateDTO"] = "BoardCreateDTO";
    GalEvents["BoardDestroyDTO"] = "BoardDestroyDTO";
    GalEvents["BoardEnterDTO"] = "BoardEnterDTO";
    GalEvents["CancelDTO"] = "CancelDTO";
    GalEvents["ChallengeBeginDTO"] = "ChallengeBeginDTO";
    GalEvents["ChallengeCompleteDTO"] = "ChallengeCompleteDTO";
    GalEvents["ChallengeMilestoneDTO"] = "ChallengeMilestoneDTO";
    GalEvents["CheckoutFlowEnteredDTO"] = "CheckoutFlowEnteredDTO";
    GalEvents["CraftCompleteDTO"] = "CraftCompleteDTO";
    GalEvents["CraftRequestDTO"] = "CraftRequestDTO";
    GalEvents["CurrencySelectorOpenedDTO"] = "CurrencySelectorOpenedDTO";
    GalEvents["EmailSignupDTO"] = "EmailSignupDTO";
    GalEvents["EmailVerificationCompleteDTO"] = "EmailVerificationCompleteDTO";
    GalEvents["EmailVerificationSendDTO"] = "EmailVerificationSendDTO";
    GalEvents["ErrorDTO"] = "ErrorDTO";
    GalEvents["ExternalWalletConnectionDTO"] = "ExternalWalletConnectionDTO";
    GalEvents["FTUEDTO"] = "FTUEDTO";
    GalEvents["GameDownloadCompleteDTO"] = "GameDownloadCompleteDTO";
    GalEvents["GameDownloadDTO"] = "GameDownloadDTO";
    GalEvents["GameDownloadStartDTO"] = "GameDownloadStartDTO";
    GalEvents["GameGiveAllowanceDTO"] = "GameGiveAllowanceDTO";
    GalEvents["GameInstallCompleteDTO"] = "GameInstallCompleteDTO";
    GalEvents["GameInstallQueueDTO"] = "GameInstallQueueDTO";
    GalEvents["GameInstallStartDTO"] = "GameInstallStartDTO";
    GalEvents["GameplayBeginDTO"] = "GameplayBeginDTO";
    GalEvents["GameUpdateCompleteDTO"] = "GameUpdateCompleteDTO";
    GalEvents["GameUpdateStartDTO"] = "GameUpdateStartDTO";
    GalEvents["HarvestCompleteDTO"] = "HarvestCompleteDTO";
    GalEvents["LauncherAgreementAcceptDTO"] = "LauncherAgreementAcceptDTO";
    GalEvents["LauncherCheckInstalledGamesCompleteDTO"] = "LauncherCheckInstalledGamesCompleteDTO";
    GalEvents["LauncherCheckInstalledGamesStartDTO"] = "LauncherCheckInstalledGamesStartDTO";
    GalEvents["LauncherConnectionCloseDTO"] = "LauncherConnectionCloseDTO";
    GalEvents["LauncherConnectionCompleteDTO"] = "LauncherConnectionCompleteDTO";
    GalEvents["LauncherConnectionStartDTO"] = "LauncherConnectionStartDTO";
    GalEvents["LauncherDownloadStartDTO"] = "LauncherDownloadStartDTO";
    GalEvents["LauncherSetVersionDTO"] = "LauncherSetVersionDTO";
    GalEvents["LauncherUpdateCompleteDTO"] = "LauncherUpdateCompleteDTO";
    GalEvents["LauncherUpdateStartDTO"] = "LauncherUpdateStartDTO";
    GalEvents["LoginDTO"] = "LoginDTO";
    GalEvents["LogoutDTO"] = "LogoutDTO";
    GalEvents["MilestoneDTO"] = "MilestoneDTO";
    GalEvents["NavigateDTO"] = "NavigateDTO";
    GalEvents["ObjectMoveDTO"] = "ObjectMoveDTO";
    GalEvents["ObjectPlaceDTO"] = "ObjectPlaceDTO";
    GalEvents["ObjectRemoveDTO"] = "ObjectRemoveDTO";
    GalEvents["PackCloseDTO"] = "PackCloseDTO";
    GalEvents["PackShowOfferDTO"] = "PackShowOfferDTO";
    GalEvents["PackSignupClickDTO"] = "PackSignupClickDTO";
    GalEvents["PageViewDTO"] = "PageViewDTO";
    GalEvents["PressDTO"] = "PressDTO";
    GalEvents["ProductionCompleteDTO"] = "ProductionCompleteDTO";
    GalEvents["PurchaseAttemptDTO"] = "PurchaseAttemptDTO";
    GalEvents["PurchaseCompleteDTO"] = "PurchaseCompleteDTO";
    GalEvents["PurchaseFulfillDTO"] = "PurchaseFulfillDTO";
    GalEvents["RankingDTO"] = "RankingDTO";
    GalEvents["RegisterDTO"] = "RegisterDTO";
    GalEvents["SelectedCurrencyChangedDTO"] = "SelectedCurrencyChangedDTO";
    GalEvents["SelectedTransactionFeeChangedDTO"] = "SelectedTransactionFeeChangedDTO";
    GalEvents["SessionPingDTO"] = "SessionPingDTO";
    GalEvents["SessionStartDTO"] = "SessionStartDTO";
    GalEvents["SettingChangeDTO"] = "SettingChangeDTO";
    GalEvents["StorageFlushDTO"] = "StorageFlushDTO";
    GalEvents["StoreDTO"] = "StoreDTO";
    GalEvents["SystemOrderFulfilledDTO"] = "SystemOrderFulfilledDTO";
    GalEvents["SystemOrderCreatedDTO"] = "SystemOrderCreatedDTO";
    GalEvents["SystemOrderCancelledDTO"] = "SystemOrderCancelledDTO";
    GalEvents["SystemOrderReversedDTO"] = "SystemOrderReversedDTO";
    GalEvents["SystemNewUserDTO"] = "SystemNewUserDTO";
    GalEvents["TradeDTO"] = "TradeDTO";
    GalEvents["TwoFactorChallengeDTO"] = "TwoFactorChallengeDTO";
    GalEvents["TwoFactorSetupDTO"] = "TwoFactorSetupDTO";
    GalEvents["TwoFactorVerifyDTO"] = "TwoFactorVerifyDTO";
    GalEvents["GameUIViewDTO"] = "GameUIViewDTO";
    GalEvents["GameUIInteractionDTO"] = "GameUIInteractionDTO";
    GalEvents["GameEventDTO"] = "GameEventDTO";
    GalEvents["GameEconomyDTO"] = "GameEconomyDTO";
    GalEvents["UninformedErrorDTO"] = "UninformedErrorDTO";
    GalEvents["WalletCreateDTO"] = "WalletCreateDTO";
    GalEvents["SessionEndDTO"] = "SessionEndDTO";
    GalEvents["JoinTableDTO"] = "JoinTableDTO";
    GalEvents["LeaveTableDTO"] = "LeaveTableDTO";
    GalEvents["BuyInDTO"] = "BuyInDTO";
    GalEvents["HandBeginDTO"] = "HandBeginDTO";
    GalEvents["HandDealtDTO"] = "HandDealtDTO";
    GalEvents["HandActionDTO"] = "HandActionDTO";
    GalEvents["TableStateChangeDTO"] = "TableStateChangeDTO";
    GalEvents["HandDeltaDTO"] = "HandDeltaDTO";
    GalEvents["TableGiftDTO"] = "TableGiftDTO";
    GalEvents["TableMessageDTO"] = "TableMessageDTO";
    GalEvents["ChipPurchaseDTO"] = "ChipPurchaseDTO";
    GalEvents["TicketBalanceChangeDTO"] = "TicketBalanceChangeDTO";
    GalEvents["ChipResetDTO"] = "ChipResetDTO";
    GalEvents["PokerLeaderboardDTO"] = "PokerLeaderboardDTO";
})(GalEvents = exports.GalEvents || (exports.GalEvents = {}));
